/** Every fan-facing string the Survivor Game tab renders (ISSUE-973). Plain American English, sentence case, no dashes. */

export const SURVIVOR_ROUNDS_LABEL = "Rounds";
export const SURVIVOR_MY_PICKS_HEADING = "My picks";
export const SURVIVOR_MATCHES_HEADING = "Matches";
export const SURVIVOR_PICK_LABEL = "Pick";
export const SURVIVOR_PICKED_LABEL = "Picked";
export const SURVIVOR_PRIORITY_LABEL = "Priority";
export const SURVIVOR_STATUS_LABEL = "Status";
export const SURVIVOR_SUBMITTED_LABEL = "Submitted";
export const SURVIVOR_LOCK_LABEL = "Lock";
export const SURVIVOR_STATUS_IN = "In";
export const SURVIVOR_STATUS_REVIVED = "Revived";
export const SURVIVOR_STATUS_ELIMINATED = "Eliminated";
export const SURVIVOR_STATUS_NOT_PLAYING = "Not playing";
export const SURVIVOR_LOCKED_VALUE = "Locked";
export const SURVIVOR_UNDER_A_MINUTE = "Under a minute";
export const SURVIVOR_MISSED_PICK_NOTE =
  "Picks you haven't made by the lock count as losses.";
export const SURVIVOR_ROUND_FULL_NOTE =
  "You've made all your picks for this round. Remove one to pick another.";
export const SURVIVOR_OUTCOME_WON = "Won";
export const SURVIVOR_OUTCOME_LOST = "Lost";
export const SURVIVOR_OUTCOME_TIE = "Tie";
export const SURVIVOR_OUTCOME_PENDING = "Pending";
export const SURVIVOR_OUTCOME_NOT_SAVED = "Not saved yet";
export const SURVIVOR_GAME_LIVE = "Live";
export const SURVIVOR_GAME_FINAL = "Final";
export const SURVIVOR_GAME_POSTPONED = "Postponed";
export const SURVIVOR_GAME_CANCELED = "Canceled";
export const SURVIVOR_GAME_DELAYED = "Delayed";
export const SURVIVOR_GAME_NOT_FINAL = "Not final";
export const SURVIVOR_ADD_ENTRY_LABEL = "Add another entry";
export const SURVIVOR_ADDING_ENTRY_LABEL = "Adding another entry";

export function survivorRoundLabel(ordinal: number): string {
  return `Round ${ordinal}`;
}
export function survivorFromNowLabel(
  count: number,
  unit: "minute" | "hour" | "day",
): string {
  return count === 1
    ? `${count} ${unit} from now`
    : `${count} ${unit}s from now`;
}
export function survivorVersusLabel(opponentName: string): string {
  return `vs ${opponentName}`;
}
export function survivorRemoveLabel(teamName: string): string {
  return `Remove ${teamName}`;
}
export function survivorMoveLabel(teamName: string, priority: number): string {
  return `Move ${teamName} to priority ${priority}`;
}
/** ISSUE-1331. The Game tab's contest menu and its look-back notes. */
export const SURVIVOR_CONTEST_MENU_LABEL = "Contest";
export const SURVIVOR_CONTEST_MENU_PLACEHOLDER = "Look back at a contest";
export function survivorLookBackNote(contestName: string): string {
  return `You're looking back at ${contestName}. These picks can't be changed.`;
}
export function survivorLookBackNoEntryNote(contestName: string): string {
  return `You didn't play in ${contestName}. Everyone's picks are on the Results tab.`;
}

/** "1 pick", "2 picks": a count with the word that agrees with it. */
export function countOf(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}

/** Picks the eligible games cannot cover carry forward (#102). */
export function survivorShortageNote(
  shortageCount: number,
  eligiblePickCapacity: number,
): string {
  const supply =
    eligiblePickCapacity === 0
      ? "no eligible games are"
      : `only ${countOf(eligiblePickCapacity, "eligible game is", "eligible games are")}`;
  return `${countOf(shortageCount, "pick carries", "picks carry")} forward because ${supply} available under your team-use rules. Missing an available pick does not create a shortage.`;
}

/** Makeup picks added on top of this round's own requirement (#102). */
export function survivorMakeupNote(applied: number, remaining: number): string {
  const added = `${countOf(applied, "carry-over pick", "carry-over picks")} added to this round’s normal requirement.`;
  return remaining === 0
    ? `${added} Nothing more is owed after this round.`
    : `${added} ${countOf(remaining, "pick is", "picks are")} still owed after this round’s available games.`;
}

/** Makeup picks this round cannot hold, moved to a later one (#102). */
export function survivorDeferredNote(deferred: number): string {
  return `${countOf(deferred, "unplayed pick", "unplayed picks")} deferred to a later round.`;
}
